import { styled } from '@vw-marketing/us-components';

export const CarHeaderContainer: any = styled.div`
  width: 100%;
  border-top: solid 1px #dfe4e8;
  border-bottom: solid 1px #dfe4e8;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  padding: 33px 0 46px 0;
  margin-bottom: 50px;
`;
